import { useState } from 'react'
import TabList from 'share-ui/components/Tabs/TabList/TabList'
import Tab from 'share-ui/components/Tabs/Tab/Tab'
import TabsContext from 'share-ui/components/Tabs/TabsContext/TabsContext'
import TabPanels from 'share-ui/components/Tabs/TabPanels/TabPanels'
import TabPanel from 'share-ui/components/Tabs/TabPanel/TabPanel'
import { StyledFormHeader } from 'styles/formStyles.css'
import General from './BrowsePanels/General'
import Settings from './BrowsePanels/Settings'
import { useChat } from './useChat'
import styled from 'styled-components'

import { StyledChatWrapper, StyledContainer, StyledMainWrapper } from 'routes/ChatRouteLayout'
import { StyledAppContainer } from 'components/Layout/LayoutStyle'

const Browse = () => {
    const [activeTab, setActiveTab] = useState(0)
    const [hideHeader, setHideHeader] = useState(false)
    const handleTabClick = (tabId: number) => {
        setActiveTab(tabId)
    }

    const { handleSendMessage, twitterPosts, posts } = useChat()

    return (
        <StyledAppContainer>
            <StyledContainer>
                <StyledMainWrapper>
                    <StyledChatWrapper>
                        {!hideHeader && (
                            <StyledFormHeader>
                                <TabList activeTabId={activeTab} noBorder>
                                    <Tab onClick={() => handleTabClick(0)}>General</Tab>
                                    <Tab onClick={() => handleTabClick(1)}>Settings</Tab>
                                </TabList>
                            </StyledFormHeader>
                        )}
                        <StyledWrapper hideHeader={hideHeader}>
                            <TabsContext activeTabId={activeTab}>
                                <TabPanels noAnimation>
                                    <TabPanel>
                                        <General
                                            twitterPosts={twitterPosts}
                                            posts={posts}
                                            setHideHeader={setHideHeader}
                                            headerState={hideHeader}
                                        />
                                    </TabPanel>
                                    <TabPanel>
                                        <Settings handleSendMessage={handleSendMessage} />
                                    </TabPanel>
                                </TabPanels>
                            </TabsContext>
                        </StyledWrapper>
                    </StyledChatWrapper>
                </StyledMainWrapper>
            </StyledContainer>
        </StyledAppContainer>
    )
}

export default Browse

const StyledWrapper = styled.div<{ hideHeader: boolean }>`
    padding-left: 20px;
    width: 100%;
    height: ${({ hideHeader }) => (hideHeader ? '100%' : 'calc(100% - 60px)')};
`
